import axios from "axios";

const api = axios.create({
    baseURL: process.env.API_URL,
    withCredentials: true,
});

export const setupInterceptors = (store) => {
    api.interceptors.request.use(
        (config) => {
            const accessToken = store.getState().auth.accessToken;

            if (accessToken) {
                config.headers.Authorization = `Bearer ${accessToken}`;
            }

            return config;
        },
        (error) => Promise.reject(error)
    );
};

export default api;